import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';
import genFranchiseOptions from '~/utility/genFranchiseOptions';

import Label from '../../label';
import { SelectContainer } from '../styles';

/* NOTE:
 * The available teams to choose from will depend on whatever the time frame is set to.
 * In the previous iteration there was a place in the state store to hold the possible team values.
 * The other components don't need to know the options, but only the value so the options should be local state.
 */
const FranchiseSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setTeamCode = (e, { value }) => {
        dispatch(reportActionCreators.setFranchiseId(value));
        dispatch(reportActionCreators.runReport());
    };

    const statsConfig = useSelector((state) => state.config);
    const franchiseId = useSelector((state) => state.playersAndTeams.report.current.franchiseId);

    const dropdownOptions = genFranchiseOptions(statsConfig, intl.formatMessage(commonMessages.labels.allFranchises));
    const value = !franchiseId ? dropdownOptions[0] : dropdownOptions.find((obj) => obj.value === franchiseId);

    return (
        <SelectContainer>
            <Label htmlFor="franchise">{intl.formatMessage(commonMessages.labels.franchise)}</Label>
            <Select
                onOptionChange={setTeamCode}
                options={dropdownOptions}
                selectedOption={value}
                name="franchise"
                isSearchEnabled
                optionsBoxAriaLabel={intl.formatMessage(commonMessages.labels.franchise)}
                dropdownButtonAriaLabel=""
            />
        </SelectContainer>
    );
};

export default React.memo(FranchiseSelect);
